import { useCallback } from 'react';
import { TFormField } from 'js/components/common/Form/types';

import { getFieldValidations } from '../../../helpers';

export const useLookupValidate = (innerField: TFormField) => {
    return useCallback((value: string) => {
        if (!innerField) {
            return null;
        }

        const validations = getFieldValidations(innerField)?.[innerField.name] || [];
        const requiredValidationConf = validations.find(conf => conf.type === 'required');

        if (!requiredValidationConf || value) {
            return null;
        }

        return requiredValidationConf.error;
    }, [innerField]);
};
